import { useLayoutEffect, useState } from "react";
import appController from "@/modules/appController";
import MainWindow from "@/components/MainWindow";
import { experienceStore } from "@/stores/experience/store";
import type { ExperienceState } from "@/types/state";

// Logged once per page load, not once per App mount (chain advances remount App).
let hasLoggedVersion = false;

function onApplicationEvent(e: Record<string, unknown>) {
  appController.onApplicationEvent(e);
}

export default function App() {
  // A new wrapper object on every store change re-renders App even though the
  // store passes the same live model object each time.
  const [state, setState] = useState<{ experienceState: ExperienceState }>(
    () => {
      const experienceState = experienceStore.getState();
      appController.setState(experienceState);
      return { experienceState };
    },
  );

  // Layout effect: runs and cleans up in the commit, where componentDidMount
  // and componentWillUnmount ran.
  useLayoutEffect(() => {
    window.pixmoto = window.pixmoto || {};
    window.pixmoto.version = process.env.PIXMOTO_PLAY_VERSION;
    if (!hasLoggedVersion) {
      hasLoggedVersion = true;
      console.info(`Pix Pulse v${process.env.PIXMOTO_PLAY_VERSION}`);
    }

    // appController gets the new state synchronously, inside the dispatch.
    const unsubscribeExperience = experienceStore.subscribe(model => {
      appController.setState(model);
      setState({ experienceState: model });
    });
    appController.activateApplication();

    return () => {
      appController.deactivateApplication();
      unsubscribeExperience();
    };
  }, []);

  return (
    <MainWindow
      experienceState={state.experienceState}
      onApplicationEvent={onApplicationEvent}
    />
  );
}
